<div class="{{box.style}}">
  <!-- PRINT ROWS -->
  <div ds-row
    *ngFor="let row of metadataBoxConfiguration?.rows"
    [row]="row"
    [item]="item"
    [box]="box"
    class="row">
  </div>
</div>
